<template>
<div class="settings-staff-new page noscroll">
	<div class="header">
		<div class="layout-row flex-center">
			<router-link class="small-btn margin-r-10"
			             to="/settings/staff" >
				<inline-svg :src="require('@/assets/img/back_bt_arrow.svg')" />
			</router-link>

			<h3>New team member</h3>
		</div>
		<div class="flex"></div>
		<v-button label="Add team member" class="margin-r-25" @click="create"
		          :disabled="!valid" :loading="saving"  />

		<router-link class="btn brdr_btn" to="/settings/staff" >
			Cancel
		</router-link>
	</div>
	<div class="content scroll">
		<div class="layout-column">
			<div class="layout-row ">
				<input-field class="flex" label="First name" v-model="newStaff.first_name" />
				<div class="" style="width: 40px"></div>
				<input-field class="flex" label="Last name" v-model="newStaff.last_name" />
			</div>
			<div class="layout-column margin-t-25">
				<div class="layout-row">
					<input-field type="email" class="flex" required label="Email address" v-model="newStaff.email" placeholder="New user's email address" />
				</div>
				<span class="email-note">We will be sending an email to the user asking them to verify their account and set a new password.</span>
			</div>
			<div class="layout-column margin-t-25 margin-b-10">
				<h3>Permissions</h3>
				<div class="layout-column margin-t-15">
					<label class="permission" v-for="(perm,index) in permissions">
						<div class="layout-column flex-center">
							<input type="checkbox" v-model="perm.allow"  :disabled="perm.required"
							       @change="changed(perm.allow, index)"/>
						</div>
						<div class="layout-column">
							<span class="name">{{perm.name}}</span>
							<span class="desc">{{perm.desc}}</span>
						</div>
					</label>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import VSwitch from "@/components/base/v-switch";
import API from '@/api';

export default {
	name: "newStaff", components: {VSwitch, InputField, VButton},
	mixins:[API],
	data(){
		return {
			saving: false,
			newStaff:{
				email:'',
				first_name:'',
				last_name:'',
				password:'',
				verified:false,
				accounts:[
					{
						permissions:'',
					}
				],
			},
			permissions:[
				{id:'admin',name:'Admin',desc:'Allow full admin access to your account, can add/remove other users, can also connect/update/remove payment methods and integrations from the account.',allow:false},
				{id:'funnels',name:'Create/Update/Delete funnels',desc:'Can create new funnels or update/delete existing ones, this is necessary to modify Funnel > settings.',allow:false},
				{id:'editor',name:'Editor/Designer',desc:'Can edit/design your funnel steps and pages (including shared popups), without having access to the rest of your funnel/account.',allow:false},
				{id:'automations',name:'Automations',desc:'Can create/update/delete automations, at funnel and product level.',allow:false},
				{id:'orders',name:'Orders',desc:'Can update/fulfil/delete orders and customers.',allow:false},
				{id:'readonly',name:'Analytics/Data Read only access',desc:'Can access analytics, and orders data but cannot modify it.',allow:true, required:true},
			],
		}
	},
	computed:{
		valid() {
				return String(this.newStaff.email)
						.toLowerCase()
						.match(
								/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						);
		},
		members(){
			return this.$store.state.staff
		}
	},
	methods:{
		changed(checked, index) {
			if (checked) {
				for (let i = index+1; i < this.permissions.length; i++) {
					this.permissions[i].allow = true;
				}
			} else {
				for (let i = 0; i < index; i++) {
					this.permissions[i].allow = false;
				}
			}
		},
		async create() {
			try {
				this.saving = true;
				let data = JSON.parse(JSON.stringify(this.newStaff));
				let perms = {};
				this.permissions.forEach(x => {
					perms[x.id] = x.allow;
				})
				data.accounts[0].permissions = JSON.stringify(perms);

				let resp = await this.api.settings.createStaff(data)
				if (resp.error) {
					if (resp.info.status === 409) { // conflict
						this.$error(resp, "A member with similar email already exists")
						return;
					}
					throw resp
				}

				// reload member briefs
				let members = await this.api.settings.getStaff();
				this.$store.commit("SET_STAFF", members)


				this.$info("", "Team member created!")
				this.$router.push("/settings/staff")
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.settings-staff-new {
	display: flex;
	flex-direction: column;
	.email-note {
		font-size: 13px;
		margin-top: 5px;
		color: $dark-grey;
	}
	.header {
		border-bottom: 1px solid $light-grey;
		border-radius: 0 0 0 0;
	}
	.permission {
		display: flex;
		flex-direction: row;
		margin-bottom: 10px;
		cursor: pointer;
		input {
			appearance: auto;
			margin-right: 8px;
		}
		.name {
			font-weight: 600;
			font-size: 14px;
			color: $black;
			margin-bottom: 3px;
		}
		.desc {
			font-weight: 400;
			font-size: 13px;
			color: $dark-grey;
		}
	}
.content {
	padding: 30px 50px;
}
}
</style>
